class ProductStitcher extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        mainProduct: "[js-main-product]",
        productDetails: "[js-product-details]",
        productReviews: "[js-product-reviews]",
        metaFeaturesSpecs: "[js-product-meta-features-specs]",
        pdpContributionMain: "[js-pdp-contribution-main]",
        styledByYou: "[js-styled-by-you]",
        relatedProducts: "[js-related-products]",
        productBreadcrumb: "[js-product-breadcrumb]"
      }
  
      this.mainProduct = document.querySelector(this.selectors.mainProduct);
      this.productDetails = document.querySelector(this.selectors.productDetails);
      this.metaFeaturesSpecs = document.querySelector(this.selectors.metaFeaturesSpecs);
      this.pdpContributionMain = document.querySelector(this.selectors.pdpContributionMain);
      this.styledByYou = document.querySelector(this.selectors.styledByYou);
      this.productReviews = document.querySelector(this.selectors.productReviews);
      this.relatedProducts = document.querySelector(this.selectors.relatedProducts);
      this.productBreadcrumb = document.querySelector(this.selectors.productBreadcrumb);
      this.monogramDrawer = document.querySelector("monogram-drawer");
      this.stitcherItems = this.querySelectorAll("[js-stitcher-item]");

      this.init();
    }

    init() {
        this.stitcherItems.forEach( stitcherItem => {
            stitcherItem.addEventListener("click", this.renderSectionFromFetch.bind(this))
        });
    }

    renderSectionFromFetch({ currentTarget }) {
        const handle = currentTarget.getAttribute("data-product-handle");
        const availability = currentTarget.getAttribute("data-product-available");

        this.mainProduct.classList.add("section--loading");
        this.productDetails?.classList.add("section--loading");

        this.updateURLHash(handle)
        this.renderMainProduct(handle, availability);
        this.renderProductDetails(handle);
        this.renderMetaFeaturesSpecs(handle);
        this.renderPdpContributionMain(handle);
        this.renderStyledByYou(handle);
        this.renderProductReviews(handle);
        this.renderRelatedProducts(handle);
        this.renderProductBreadcrumbs(handle);
    }

    updateURLHash(handle) {
        window.history.replaceState({}, '', handle);
    }

    renderMainProduct(handle, availability) {
        const url = `/products/${handle}?section_id=${this.mainProduct?.getAttribute("data-section-id")}`;
        this.renderSection(url, this.mainProduct, this.selectors.mainProduct, availability)
    }

    renderProductDetails(handle) {
        const url = `/products/${handle}?section_id=${this.productDetails?.getAttribute("data-section-id")}`;
        this.renderSection(url, this.productDetails, this.selectors.productDetails)
    }

    renderMetaFeaturesSpecs(handle) {
        const url = `/products/${handle}?section_id=${this.metaFeaturesSpecs?.getAttribute("data-section-id")}`;
        this.renderSection(url, this.metaFeaturesSpecs, this.selectors.metaFeaturesSpecs)
    }

    renderPdpContributionMain(handle) {
        const url = `/products/${handle}?section_id=${this.pdpContributionMain?.getAttribute("data-section-id")}`;
        this.renderSection(url, this.pdpContributionMain, this.selectors.pdpContributionMain)
    }

    renderStyledByYou(handle) {
        const url = `/products/${handle}?section_id=${this.styledByYou?.getAttribute("data-section-id")}`;
        this.renderSection(url, this.styledByYou, this.selectors.styledByYou)
    }

    renderProductReviews(handle) {
        const url = `/products/${handle}?section_id=${this.productReviews?.getAttribute("data-section-id")}`;
        this.renderSection(url, this.productReviews, this.selectors.productReviews)
    }
    
    renderRelatedProducts(handle) {
        const url = `/products/${handle}?section_id=${this.relatedProducts?.getAttribute("data-section-id")}`;
        this.renderSection(url, this.relatedProducts, this.selectors.relatedProducts)
    }

    renderProductBreadcrumbs(handle) {
        const url = `/products/${handle}?section_id=${this.productBreadcrumb?.getAttribute("data-section-id")}`;
        this.renderSection(url, this.productBreadcrumb, this.selectors.productBreadcrumb)
    }

    renderSection(url, container, selector, availability) {
        fetch(url)
        .then((response) => response.text())
        .then((html) => {
            const ajaxContainer = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector);
            if(container && ajaxContainer) {
                container.innerHTML = ajaxContainer.innerHTML;
            }
        })
        .finally(() => {
            if(selector === this.selectors.mainProduct) {
                const currentVariantId = this.mainProduct.querySelector(".product-variant-id")?.value;
                this.monogramDrawer.setAttribute("data-variant-id", currentVariantId);
                document.dispatchEvent(new CustomEvent("fancyboxPdp:init"));
                document.dispatchEvent(new CustomEvent("fancyboxPdp1:init"));

                document.dispatchEvent(new CustomEvent("options-label:init"));
                document.dispatchEvent(new CustomEvent("monogram-btn:init"));
                document.dispatchEvent(new CustomEvent("notify-form:init"));
                document.dispatchEvent(new CustomEvent("magnify:init"));
                document.dispatchEvent(new CustomEvent("custom-quick-add-to-cart:init"));
                document.dispatchEvent(new CustomEvent("shipping-message:init"));

                document.dispatchEvent(new CustomEvent("imageWidth:init"));
                document.dispatchEvent(new CustomEvent("combo-widget-selector:init"));

                this.mainProduct.classList.remove("section--loading");

                if(availability === 'false') {
                    document.getElementById('klaviyo-bis-iframe').remove();
                    document.querySelectorAll('[js-hb-klaviyo-script]').forEach(tag => {
                        tag.remove();
                    })
                    klaviyo = '';
                    klaviyoBIS = '';
    
                    const scriptTag = document.createElement('script');
                    scriptTag.src = 'https://a.klaviyo.com/media/js/onsite/onsite.js';
                    scriptTag.setAttribute('js-hb-klaviyo-script', '');
                    document.body.append(scriptTag);
    
                    setTimeout(() => {
                        console.log({ klaviyo })
                        klaviyo.init({
                            account: "Hqr8HK", 
                            platform: "shopify"
                        });
                        klaviyo.enable("backinstock",{ 
                            trigger: {
                                product_page_text: "NOTIFY ME WHEN AVAILABLE",
                                product_page_class: "button",
                                product_page_text_align: "center",
                                product_page_margin: "0px",
                                replace_anchor: false
                            },
                            modal: {
                                headline: "{product_name}",
                                body_content: "Register to receive a notification when this item comes back in stock.",
                                email_field_label: "Email",
                                button_label: "NOTIFY ME WHEN AVAILABLE",
                                subscription_success_label: "You're in! We'll let you know when it's back.",
                                footer_content: '',
                                additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
                                drop_background_color: "#000",
                                background_color: "#fff",
                                text_color: "#222",
                                button_text_color: "#fff",
                                button_background_color: "#986473",
                                close_button_color: "#ccc",
                                error_background_color: "#fcd6d7",
                                error_text_color: "#C72E2F",
                                success_background_color: "#d3efcd",
                                success_text_color: "#1B9500"
                            }
                        });    
                    }, 1000)
                }

            } else if(selector === this.selectors.productDetails) {
                document.dispatchEvent(new CustomEvent("accordion:init"));
                document.dispatchEvent(new CustomEvent("custom-quick-add-to-cart:init"));
                document.dispatchEvent(new CustomEvent("complete-the-look:init"));

                document.dispatchEvent(new CustomEvent("imageWidth:init"));
                document.dispatchEvent(new CustomEvent("pdp-collection-slider:init"));
                document.dispatchEvent(new CustomEvent("card-media-gallery:init"));

                this.productDetails.classList.remove("section--loading");
            } else if(selector === this.selectors.metaFeaturesSpecs) { 
                document.dispatchEvent(new CustomEvent("accordion:init"));
                document.dispatchEvent(new CustomEvent("custom-quick-add-to-cart:init"));
                
                document.dispatchEvent(new CustomEvent("tabs-collection-new:init"));
                document.dispatchEvent(new CustomEvent("pdp-collection-slider:init"));
                document.dispatchEvent(new CustomEvent("card-media-gallery:init"));
            }else if(selector === this.selectors.styledByYou) { 
                document.dispatchEvent(new CustomEvent("styled-by-you-slider:init"));
            }
        });
    }
};

customElements.define('product-stitcher', ProductStitcher);